<template>
    <div>
        <section class="user_profile inner_pages">
            <div class="container">
                <div class="row">
                    <div class="col-md-3 col-sm-3">
                        <div class="profile_nav">
                            <ul>
                                <!-- <li>
                                    <a href="/mi_perfil">Mi perfil</a>
                                </li> -->
                                <li class="active">
                                    <a href="/admin/retoma_de_usados">Mis Retomas</a>
                                </li>
                                <!-- <li>
                                    <a href="/reportar_vehiculo"
                                        >Reportar Vehículo</a
                                    >
                                </li> -->
                            </ul>
                        </div>
                    </div>
                    <div class="col-md-6 col-sm-8">
                        <div class="profile_wrap">
                            <h5 class="uppercase underline">
                                Mis Retomas <span>({{ inventario.length }} vehículos)</span>
                            </h5>
                            <div class="my_vehicles_list">
                                <ul class="vehicle_listing" v-for="(vehiculo, index) in inventario" :key="index">
                                    <li>
                                        <div class="vehicle_img">
                                            <a href="#"
                                                ><img
                                                    :src="rotate_image(vehiculo.fotos.foto_principal)"
                                                    alt="image"
                                            /></a>
                                        </div>
                                        <div class="vehicle_title">
                                            <h6 class="mb-o">
                                                <a href="#"
                                                    >{{ vehiculo.marca }} {{ vehiculo.linea }} {{ vehiculo.modelo }}</a
                                                >
                                                <small>{{vehiculo.version}}</small>
                                                <div>
                                                    <small>{{ vehiculo.kilometraje | formatNumber }} Km</small>
                                                </div>
                                            </h6>
                                        </div>
                                        <div class="vehicle_status">
                                            <a
                                                href="#"
                                                class="btn outline btn-xs btn"
                                                >Publicado</a
                                            >
                                            <div class="clearfix"></div>
                                            <a href="#"> $ {{ vehiculo.precio | formatNumber }}</a> <br>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    props: ['vehiculos'],
    computed: {
        ...mapFields("buscador", [
            "inventario",
            "links"
        ])
    },
    created() {
        this.inventario = this.vehiculos;
        console.log(this.vehiculos)
        const { data, ...links } = this.vehiculos;
        this.links = links;
    },
    methods: {
        rotate_image(id_image) {
            return (
                "https://d16vbrqyk5474c.cloudfront.net/fit-in/1280x720/" +
                id_image
            );
        }
    }
};
</script>

<style lang="scss" scoped></style>
